

import React, { useRef } from 'react'

import { Flex } from '@stackhouse/styled-elements'

import Text from '@stackhouse/dashboard-components/Text'
import Toast from '@stackhouse/dashboard-components/Toast'
import Modal from '@stackhouse/dashboard-components/Modal'
import Button from '@stackhouse/dashboard-components/Button'
import { withDashboardContext } from '@stackhouse/dashboard-components/Dashboard'

import Form from '../../components/ResponsiveForm'


const changePasswordFields = {
    newPassword: {
        group: 0,
        type: 'text',
        id: 'newPassword',
        label: 'New password',
        password: true,
        required: true,
        autofocus: true,
    },
    confirmPassword: {
        group: 1,
        type: 'text',
        id: 'confirmPassword',
        label: 'Confirm password',
        password: true,
        required: true,
        validate: (value, field, { newPassword }) => {
            if (value != newPassword) {
                return 'Password and confirmation password do not match.'
            }
        }
    },
}


const ChangePasswordModal = withDashboardContext(({ close, title, canCancel, username, client, withLoader }) => {

    const formRef = useRef(null)

    const save = () => {
        if (formRef.current && formRef.current.isValid()) {
            const { newPassword } = formRef.current.getValue()
            return withLoader(done => {
                return client.post('/User/changePassword', { username, newPassword }).then(() => {
                    setTimeout(Toast.toast({
                        type: 'success',
                        fixed: true,
                        showCloseButton: false,
                        text: `Password changed successfully.`,
                    }), 3000)
                }).then(done).then(close).catch(done)
            })
        }
    }

    return (
        <Flex column justifyCenter p={'1em'} backgroundColor={'white'} borderRadius={10}>
            {title ? <Text color={'theme(colors.primary)'} alignCenter>{title}</Text> : null}
            <Flex column>
                <Form ref={formRef} fields={changePasswordFields} />
            </Flex>
            <Flex row alignCenter justifyEvenly p={10}>
                {canCancel ? <Button flex={1} outline title={'Cancel'} onClick={close} /> : null}
                <Button flex={1} ml={'1em'} title={'Change password'} onClick={save} />
            </Flex>
        </Flex>
    )
}, ({ client, withLoader }) => ({ client, withLoader }))


export default ({ username, title, canCancel = true }, modalProps = {}) => {

    return Modal.show(
        ({ close }) => (<ChangePasswordModal title={title} canCancel={canCancel} close={close} username={username} />),
        { target: 'root', animation: 'zoom', ...modalProps }
    )
}
